<div class="testimonial-slider-wrapper ">
    <img src="../../assets/images/quotes.svg" alt="quotes" />
    <h2 class="section-heading">What Customers Say About Us</h2>
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let slide of slides" class="slide">
            <div class="testimonial-wrapper-inner">
                <div class="testimonial-image">
                    <img src="{{ slide.img }}" alt="" width="100%">
                </div>
                <div class="testimonial-description">
                    <h2>{{ slide.testimonialName }}</h2>
                    <span>{{ slide.companyType }}</span>
                    <p>{{ slide.testimonilaMessage }}</p>
                </div>
            </div>

        </div>
    </ngx-slick-carousel>
</div>